const factory = (Model, AvatarUrl) => {
  let Person;
  return (Person = (() => {
    // eslint-disable-next-line no-shadow
    Person = class Person extends Model {
      static initClass() {
        this.prototype.id = null;
        this.prototype.firstName = null;
        this.prototype.lastName = null;
        this.prototype.fullName = null;
        this.prototype.phone = null;
        this.prototype.email = null;
        this.prototype.company = null;
        this.prototype.smsOptIn = null;
        this.prototype.phoneNumberError = null;

        this.prototype.$resource = 'person';
      }

      $resetPassword() {
        return this.$apiCall({
          method: 'POST',
          url: `${this.$getUrl()}reset_password/${this.email}`,
        });
      }

      $getEnrolledMultifactorDevices() {
        return this.$apiCall({
          method: 'GET',
          url: `${this.$getUrl(this.id)}/mfa`,
        });
      }

      $enrollMultifactorDevice() {
        return this.$apiCall({
          method: 'PUT',
          url: `${this.$getUrl(this.id)}/mfa/enroll/true`,
        });
      }

      $clearAllMultifactorDevices() {
        return this.$apiCall({
          method: 'DELETE',
          url: `${this.$getUrl(this.id)}/mfa`,
        });
      }

      $changeEmail(password, newEmail) {
        return this.$apiCall({
          method: 'POST',
          url: `${this.$getUrl()}change_email/${this.id}`,
          data: { password, newEmail },
        });
      }

      $avatarURL(size = 40) {
        return AvatarUrl.getAvatar(this.email, size);
      }

      $getInitials() {
        return this.fullName != null
          ? this.fullName
              .split(' ')
              .map(x => x.slice(0, 1))
              .join('')
          : undefined;
      }

      $fetch() {
        return this.$apiCall({
          method: 'GET',
          url: `${this.$getUrl()}${this.id}`,
        }).then(res => {
          this.$set(res.data);
        });
      }
    };
    Person.initClass();
    return Person;
  })());
};

const moduleDeps = [require('data/util').name];

module.exports = angular.module('bench.data.model.person', moduleDeps).factory('Person', factory);
